(function () {
  'use strict';
  var config = window.BFVIP;
  var gate = document.getElementById('bf-vip-gate');
  if (!config || !gate || config.authorized) return;

  var form = document.getElementById('bf-vip-password-form');
  var input = document.getElementById('bf-vip-password');
  var error = document.getElementById('bf-vip-error');
  var reveal = document.getElementById('bf-vip-toggle-password');
  var emailToggle = document.getElementById('bf-vip-email-toggle');
  var emailPanel = document.getElementById('bf-vip-email-panel');
  var previousFocus = document.activeElement;
  var blocked = new Map();

  if (emailToggle && emailPanel) {
    emailToggle.addEventListener('click', function () {
      var expanded = emailToggle.getAttribute('aria-expanded') === 'true';
      emailToggle.setAttribute('aria-expanded', String(!expanded));
      emailPanel.hidden = expanded;
    });
  }
  // Keep background navigation, app widgets and forms out of the focus order.
  function blockBackground(element) {
    if (!(element instanceof HTMLElement) || element === gate || blocked.has(element)) return;
    if (element.tagName === 'SCRIPT' || element.tagName === 'STYLE') return;
    blocked.set(element, { inert: element.inert, ariaHidden: element.getAttribute('aria-hidden') });
    element.inert = true;
    element.setAttribute('aria-hidden', 'true');
  }
  Array.from(document.body.children).forEach(blockBackground);
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) { Array.from(mutation.addedNodes).forEach(blockBackground); });
  });
  observer.observe(document.body, { childList: true });

  function keepFocus(event) {
    if (!gate.hidden && !gate.contains(event.target)) input.focus({ preventScroll: true });
  }
  document.addEventListener('focusin', keepFocus);
  gate.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var focusable = Array.from(gate.querySelectorAll('input, button, summary, a[href], select, textarea, [tabindex="0"]'))
      .filter(function (element) { return !element.disabled && element.getClientRects().length > 0; });
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  reveal.addEventListener('click', function () {
    var show = input.type === 'password';
    input.type = show ? 'text' : 'password';
    reveal.textContent = show ? 'Ocultar' : 'Ver';
    reveal.setAttribute('aria-label', show ? 'Ocultar contraseña' : 'Mostrar contraseña');
    reveal.setAttribute('aria-pressed', String(show));
  });
  input.addEventListener('input', function () {
    error.hidden = true;
    input.removeAttribute('aria-invalid');
  });
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (input.value.trim().toLowerCase() !== config.password) {
      error.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      input.focus();
      return;
    }
    var days = Math.max(1, Number(config.days) || 30);
    var expires = Date.now() + days * 86400000;
    if (!config.editorPreview) {
      try { localStorage.setItem(config.key, String(expires)); } catch (storageError) {}
      try {
        document.cookie = config.key + '=' + expires + '; Path=/; Max-Age=' + days * 86400 + '; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
      } catch (cookieError) {}
    }
    config.authorized = true;
    observer.disconnect();
    document.removeEventListener('focusin', keepFocus);
    blocked.forEach(function (state, element) {
      element.inert = state.inert;
      if (state.ariaHidden === null) element.removeAttribute('aria-hidden');
      else element.setAttribute('aria-hidden', state.ariaHidden);
    });
    gate.hidden = true;
    input.value = '';
    document.documentElement.classList.remove('bf-vip-locked');
    if (previousFocus && previousFocus !== document.body && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
    window.dispatchEvent(new CustomEvent('bfvip:unlocked'));
  });
  // No navigation or URL rewriting: affiliate, campaign and theme-preview parameters stay intact.
  gate.hidden = false;
  if (!config.editorPreview) {
    var initialFocus = window.matchMedia('(max-width: 760px)').matches ? gate : input;
    initialFocus.focus({ preventScroll: true });
  }
})();
